import { BriefStatus } from "./types";

export interface BriefStatusStyle {
  bg: string;
  text: string;
  dot: string;
  border: string;
  label: string;
}

export const BRIEF_STATUS_CONFIG: Record<BriefStatus, BriefStatusStyle> = {
  DRAFT: {
    bg: "bg-slate-100",
    text: "text-slate-600",
    dot: "bg-slate-400",
    border: "border-slate-200",
    label: "Bozza",
  },
  CAPTURING: {
    bg: "bg-sky-50",
    text: "text-sky-700",
    dot: "bg-sky-500",
    border: "border-sky-200",
    label: "Acquisizione",
  },
  EDITING: {
    bg: "bg-violet-50",
    text: "text-violet-700",
    dot: "bg-violet-500",
    border: "border-violet-200",
    label: "In lavorazione",
  },
  COMPLETE: {
    bg: "bg-emerald-50",
    text: "text-emerald-700",
    dot: "bg-emerald-500",
    border: "border-emerald-200",
    label: "Completato",
  },
};

